import { useEffect } from 'react'

import { useRequest } from 'ahooks'

import { queryAreaTreeApi } from '@eastcoal/api/system/area/queryAreaTree'
import { AreaEntity } from '@eastcoal/api/system/interface'

import { KeySet } from '@eastcoal/common/types/utilities'

import { useAreaTreeStoreApi } from '../hooks'
import { AreaTreeAction, AreaTreeStore } from '../store/interface'

import { AreaTreeStoreUpdaterProps } from './interface'

const useStoreUpdater = <K extends KeySet<AreaTreeStore>>(
  key: K,
  value: AreaTreeStore[K]
) => {
  const { setState } = useAreaTreeStoreApi()
  useEffect(() => {
    setState({ [key]: value })
  }, [key, value, setState])
}

const useStoreSetter = <K extends KeySet<AreaTreeAction>>(
  setter: K,
  value: Parameters<AreaTreeAction[K]>[0]
) => {
  const { getState } = useAreaTreeStoreApi()
  useEffect(() => {
    getState()[setter](value)
  }, [setter, value, getState])
}

const EMPTY_DATA: AreaEntity[] = []

export const AreaTreeStoreUpdater = ({
  value,
  onChange
}: AreaTreeStoreUpdaterProps) => {
  const {
    data = EMPTY_DATA,
    error,
    loading,
    refreshAsync
  } = useRequest(
    () =>
      queryAreaTreeApi({
        enable: true
      }),
    {
      manual: false
    }
  )

  useStoreUpdater('data', data)
  useStoreUpdater('error', error)
  useStoreUpdater('loading', loading)
  useStoreUpdater('reload', refreshAsync)

  useStoreUpdater('onChange', onChange)
  useStoreSetter('setValue', value)

  return null
}
